module.exports = __webpack_public_path__ + "static/img/12.c00a4a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/12.png
// module id = e7Lo
// module chunks = 0